module.exports = __webpack_public_path__ + "static/media/Screen4_left.f29118ba.png";